import { cn } from '@/lib/utils';

const variantStyles = {
  success: 'bg-success-soft text-success border border-success/30',
  warning: 'bg-warning-soft text-warning border border-warning/30',
  error: 'bg-danger-soft text-danger border border-danger/30',
  info: 'bg-info-soft text-info border border-info/30',
  neutral: 'bg-surface-subtle text-muted border border-border',
  accent: 'bg-accent-soft text-accent border border-accent/30',
} as const;

const sizeStyles = {
  sm: 'px-1.5 py-0 text-2xs',
  md: 'px-2 py-0.5 text-xs',
} as const;

export interface BadgeProps {
  variant?: keyof typeof variantStyles;
  /** `pill` : bords arrondis complets, pour les puces et compteurs. */
  shape?: 'rect' | 'pill';
  size?: keyof typeof sizeStyles;
  children: React.ReactNode;
  className?: string;
  title?: string;
}

export function Badge({
  variant = 'neutral',
  shape = 'rect',
  size = 'md',
  children,
  className,
  title,
}: BadgeProps) {
  return (
    <span
      title={title}
      className={cn(
        'inline-flex items-center font-medium',
        shape === 'pill' ? 'rounded-full' : 'rounded-lg',
        sizeStyles[size],
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
